import { show } from '@intercom/messenger-js-sdk'
import classes from 'classnames'
import styles from './index.module.css'

const ChatLink = ({ text, className }) => {
  const isAvailable = typeof window !== 'undefined' && window.Intercom

  if (!isAvailable) {
    return (
      <span className={classes(className)}>
        {text}
      </span>
    )
  }

  return (
    <span
      className={classes(styles.link, className)}
      onClick={() => show()}
      role="button"
      tabIndex={0}>
      {text}
    </span>
  )
}

export default ChatLink
